import { Divider, Grid, TextField } from '@mui/material'
import { useTheme } from '@mui/styles'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import {
  TextBold,
  TextRegular,
  TextSemiBold
} from '../../commonComponents/TextStyling'

import AppButton from '../../commonComponents/AppButton'
import { isEmpty, isEmptyJson, showToast } from '../../utils/AppHelper'
import serverData from '../../api/ServerData'
import AppIcon from '../../commonComponents/AppIcon'
import PasswordPopperComponent from '../../commonComponents/PasswordPopperComponent'
import { ENV } from '../../ENV'

export default function SetPasswordSubEmployer () {
  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()

  const data = location.state || {}

  const [firstName, setFirstName] = useState(data?.user?.firstname)
  const [lastName, setLastName] = useState(data?.user?.lastname)
  const [password, setPassword] = useState('')
  const [email, setEmail] = useState(data?.user?.email)
  const [companyName, setCompanyName] = useState(data?.user?.companyname)

  const [formError, setFormError] = useState({})

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (isEmptyJson(data)) {
      navigate('/login')
    }
  }, [])

  const validateForm = () => {
    const error = {}
    if (isEmpty(firstName)) {
      error.firstName = 'Please enter first name.'
    }
    if (isEmpty(lastName)) {
      error.lastName = 'Please enter last name.'
    }
    if (isEmpty(password)) {
      error.password = 'Please enter password.'
    }
    setFormError(error)
    return Object.keys(error).length === 0
  }

  const handleSubmit = () => {
    if (validateForm()) {
      setLoading(true)
      var body = {
        token: data.token,
        firstname: firstName,
        lastname: lastName,
        password: password
      }
      serverData.setPasswordSubEmployer(
        body,
        data => {
          if (data.status) {
            showToast(data.message, false)
            navigate('/login')
          } else {
            showToast(data.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error.statusText)
        }
      )
    }
  }

  return (
    <>
      <Grid
        container
        style={{
          background: theme.palette.background.paper
        }}
      >
        <Grid
          item
          xs={3}
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '10px',
            marginBottom: '10px',
            margin: '32px'
          }}
        >
          <AppIcon style={{ width: '6rem', height: 44 }} />
        </Grid>
      </Grid>
      <Grid
        container
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '20px 72px'
        }}
      >
        <Grid
          item
          xs={8}
          style={{
            border: `1px solid ${theme.palette.text.success}`,
            margin: '16px',
            display: 'flex',
            padding: '16px',
            borderRadius: '8px',
            backgroundColor: `${theme.palette.background.paper}`,
            height: 'fit-content'
          }}
        >
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', alignItems: 'flex-start' }}
            >
              <TextSemiBold
                style={{
                  color: `${theme.palette.text.success}`,
                  fontSize: '18px'
                }}
              >
                Hello {firstName} !
              </TextSemiBold>
            </Grid>
            <Grid item xs={12}>
              <TextRegular style={{ color: `${theme.palette.text.success}` }}>
                Welcone to {ENV.product_name}. Your account does not have a
                password, yet.
              </TextRegular>
            </Grid>
            <Grid item xs={12}>
              <TextRegular style={{ color: `${theme.palette.text.success}` }}>
                Please set a password of your choice and click the activate
                button.
              </TextRegular>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={8}
          style={{
            border: `1px solid ${theme.palette.border.main}`,
            margin: '16px',
            display: 'flex',
            padding: '24px',
            borderRadius: '8px',
            backgroundColor: `${theme.palette.background.paper}`,
            height: 'fit-content'
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <TextBold
                style={{
                  fontSize: '18px'
                }}
              >
                Activate your account
              </TextBold>
            </Grid>
            <Grid item xs={12}>
              <Divider
                style={{
                  background: theme.palette.border.main
                }}
              />
            </Grid>
            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <TextRegular style={{ color: theme.palette.text.grey }}>
                First name
              </TextRegular>
              <TextField
                required
                fullWidth
                value={firstName}
                error={formError.firstName}
                helperText={formError.firstName}
                onChange={e => setFirstName(e.target.value)}
              />
            </Grid>
            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <TextRegular style={{ color: theme.palette.text.grey }}>
                Last name
              </TextRegular>
              <TextField
                required
                fullWidth
                value={lastName}
                error={formError.lastName}
                helperText={formError.lastName}
                onChange={e => setLastName(e.target.value)}
              />
            </Grid>
            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <TextRegular style={{ color: theme.palette.text.grey }}>
                Email
              </TextRegular>
              <TextField required fullWidth value={email} disabled />
            </Grid>

            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <PasswordPopperComponent
                password={password}
                setPassword={setPassword}
                formError={formError.password}
                isPopper={false}
                title={'Password'}
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <TextRegular style={{ color: theme.palette.text.grey }}>
                Company name
              </TextRegular>
              <TextField required fullWidth value={companyName} disabled />
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start'
              }}
            >
              <TextRegular
                style={{
                  fontSize: '14px'
                }}
              >
                By creating an account you agree to {ENV.product_name}'s{' '}
                <span
                  style={{
                    color: theme.palette.primary.main,
                    cursor: 'pointer'
                  }}
                >
                  Terms and Use
                </span>{' '}
                and{' '}
                <span
                  style={{
                    color: theme.palette.primary.main,
                    cursor: 'pointer'
                  }}
                >
                  Privacy Policy.
                </span>
              </TextRegular>
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <AppButton
                name={'Activate your account'}
                loading={loading}
                onClick={handleSubmit}
                style={{
                  padding: '12px 27px',
                  borderRadius: '8px',
                  fontSize: '16px'
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
